export default "__VITE_ASSET__a7177000__"